interface IconProps {
  color?: string
}

export const Document = ({ color }: IconProps) => {
  return (
    <svg
      aria-hidden="true"
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.8293 7.19351V8.26645L9.50785 8.26645C9.4152 8.26645 9.3239 8.2723 9.2343 8.28364C9.28878 8.2431 9.35274 8.21421 9.42291 8.20094L18.8928 6.40927C19.3795 6.31719 19.8293 6.69391 19.8293 7.19351ZM21.5427 8.28585V7.19351C21.5427 5.61143 20.1181 4.4185 18.5771 4.71006L9.10717 6.50173C8.07864 6.69632 7.33332 7.6025 7.33332 8.65841L7.33332 10.4431C7.33328 10.4489 7.33325 10.4548 7.33325 10.4607L7.33325 23.8086C7.33325 25.7549 8.89692 27.3327 10.8258 27.3327H21.174C23.1029 27.3327 24.6666 25.7549 24.6666 23.8086V11.7906C24.6666 9.96988 23.2983 8.47166 21.5427 8.28585ZM9.04657 23.8086L9.04664 10.4526C9.05094 10.1993 9.25579 9.99527 9.50785 9.99527L21.174 9.99527C22.1567 9.99527 22.9533 10.7991 22.9533 11.7906V23.8086C22.9533 24.8001 22.1567 25.6039 21.174 25.6039H10.8258C9.84316 25.6039 9.04657 24.8001 9.04657 23.8086Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M16 14.7236C15.0497 14.7236 14.2794 15.501 14.2794 16.4598C14.2794 17.4187 15.0497 18.1961 16 18.1961C16.9503 18.1961 17.7206 17.4187 17.7206 16.4598C17.7206 15.501 16.9503 14.7236 16 14.7236ZM12.566 16.4598C12.566 14.5462 14.1035 12.9948 16 12.9948C17.8965 12.9948 19.434 14.5462 19.434 16.4598C19.434 18.3735 17.8965 19.9249 16 19.9249C14.1035 19.9249 12.566 18.3735 12.566 16.4598Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M13.1908 22.5279C13.1908 22.0505 13.5743 21.6635 14.0474 21.6635H17.9524C18.4255 21.6635 18.8091 22.0505 18.8091 22.5279C18.8091 23.0053 18.4255 23.3923 17.9524 23.3923H14.0474C13.5743 23.3923 13.1908 23.0053 13.1908 22.5279Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
